import BankRoutes from "./bank";
import JournalRoutes from "./journals";
import GLAccountsRoutes from "./gl-accounts";


export default [
    ...BankRoutes,
    ...JournalRoutes,
    ...GLAccountsRoutes,
];